module.exports = __webpack_public_path__ + "img/60.b36f8612.jpg";